/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { Component, Input } from '@angular/core';
import { ThemeService } from '../../../../../core/services';

@Component({
    selector: 'app-lb-image',
    template: '<img [src]="path()"/>',
    styles: [`
        :host {
            align-items: center;
            display: flex;
            justify-content: center;
        }

        img {
            width: 100%;
        }
    `]
})

export class LbImageComponent {
    /**
     * File including extension
     */
    @Input() public file: string;

    constructor(
        private themeService: ThemeService,
    ) {
    }

    /**
     * Return the image path from the theme.ts file
     */
    public path(): string {
        return this.themeService.getThemeImagePath() + this.file;
    }
}
